import { isObjectLike } from 'lodash';

export function getToken() {
  return localStorage.getItem('token');
}

export function setToken(token) {
  localStorage.setItem('token', token);
}

export function deleteToken() {
  return localStorage.removeItem('token');
}

/**
 * storage存储
 * @param {*} key
 * @param {*} value
 */
export function setItem(key, value) {
  let val = value;
  if (isObjectLike(value)) {
    val = JSON.stringify(value);
  }
  localStorage.setItem(`@as-storage:${key}`, val);
}

/**
 * 根据key删除
 * @param {string} key
 * @returns
 */
export function deleteItem(key) {
  return localStorage.removeItem(`@as-storage:${key}`);
}

/**
 * 获取item, 并尝试解析为JSON
 * @param {string} key
 * @returns
 */
export function getItem(key) {
  const value = localStorage.getItem(`@as-storage:${key}`);
  try {
    return JSON.parse(value);
  } catch (error) {
    return value;
  }
}
